<ng-container
  *ngIf="data?.place_loader_title && data?.place_loader_title.length > 0 && data.place_loader_simple_card; then useSimpleCardLoader;"></ng-container>
<ng-template #useSimpleCardLoader>
  <article id="struttura-responsabile" class="it-page-section anchor-offset richtext-wrapper">
    <h2 class="mb-3">{{data.place_loader_title}}</h2>
    <div class="card-wrapper card-teaser-wrapper">
      <div class="card card-teaser card-teaser-info shadow-sm mt-3 rounded"
        *ngFor="let place of data.place_loader_places">
        <div class="card-body">
          <h3 class="card-title h5">
            <a [href]="place.path.alias" class="text-decoration-none">
              {{place.title}}
            </a>
          </h3>
          <div class="card-text">
            <p>{{place.place_address}}, {{place.place_cap}}</p>
          </div>
        </div>
        <ng-container
          *ngIf="place.place_image.field_media_image?.uri?.url; then useImage; else useStandardIcon;"></ng-container>
        <ng-template #useImage>
          <div class="avatar size-xl">
            <img [src]="place.place_image?.field_media_image?.uri?.url ? getImage(place.place_image?.field_media_image?.uri?.url) : ''"
            [title]="place?.place_image?.field_media_image?.meta?.title"
            [alt]="place?.place_image?.field_media_image?.meta?.alt">
          </div>
        </ng-template>
        <ng-template #useStandardIcon>
          <div class="avatar bg-white size-xl">
            <svg class="icon" aria-hidden="true">
              <use href="bootstrap-italia/dist/svg/sprites.svg#it-pin"></use>
            </svg>
          </div>
        </ng-template>
      </div>
    </div>
  </article>
</ng-template>

<ng-container
  *ngIf="data?.place_loader_title && data?.place_loader_title.length > 0 && !data.place_loader_simple_card; then useCardLoader;"></ng-container>
<ng-template #useCardLoader>
  <div class="container p-3 p-md-5">
    <h2 class="mb-4">{{data.place_loader_title}}</h2>
    <div class="row g-4">
      <div class="col-lg-6 col-xl-4" *ngFor="let place of data?.place_loader_places">
        <!--start card-->
        <div class="card-wrapper border border-light rounded shadow-sm pb-0">
          <div class="card no-after rounded">
            <div class="img-responsive-wrapper" *ngIf="place.place_image?.field_media_image?.uri?.url">
              <div class="img-responsive img-responsive-panoramic">
                <figure class="img-wrapper">
                  <img [src]="place.place_image?.field_media_image?.uri?.url ? getImage(place.place_image?.field_media_image?.uri?.url) : ''"
                    [title]="place?.place_image?.field_media_image?.meta?.title"
                    [alt]="place?.place_image?.field_media_image?.meta?.alt">
                </figure>
              </div>
            </div>
            <div class="card-body">
              <div class="category-top">
                <p class="category">{{place?.place_type?.name}}</p>
              </div>
              <h3 class="card-title mt-16"><a [href]="place?.path?.alias"
                  class="text-decoration-none">{{place.title}}</a></h3>
              <p class="card-text text-secondary pb-3" [innerHTML]="stringSubstr(place?.place_short_description,0,255)">
              </p>
              <a class="read-more t-primary text-uppercase" [href]="place?.path?.alias">
                <span class="text">Leggi di più</span>
                <svg class="icon icon-xs ml-10" aria-label="Leggi di più">
                  <use href="bootstrap-italia/dist/svg/sprites.svg#it-arrow-right"></use>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <!--end card-->
      </div>
      <div class="d-flex justify-content-end" *ngIf="data.place_loader_anchor_link?.alias">
        <a [href]="data.place_loader_anchor_link?.alias" class="btn btn-outline-primary full-mb"
          data-element="live-button-events">
          {{data.place_loader_anchor_link?.title}}
          <svg class="icon icon-primary icon-xs ml-10" [attr.aria-label]="data.place_loader_anchor_link?.title">
            <use href="bootstrap-italia/dist/svg/sprites.svg#it-arrow-right"></use>
          </svg>
        </a>
      </div>
    </div>
  </div>
</ng-template>

<div class="container py-5" *ngIf="showMap">
  <div class="container">
    <app-map [markers]="markers" [showMap]="showMap"></app-map>
  </div>
</div>